import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ApiEndPointTarget, getApiEndPoints } from '../../shared/utils';

function extract(res) {
  return res.data.props;
}

@Injectable({
  providedIn: 'root'
})
export class FilesetService {
  private fileSetApiEndPoints = JSON.parse(getApiEndPoints(ApiEndPointTarget.Fileset));

  constructor(private http: HttpClient) { }

  getFileSetSettings(fileSetid: string) {
    const endpoint = this.fileSetApiEndPoints['settings'].replace('{fileSetid}', fileSetid);
    return this.http.get(endpoint)
      .pipe(map(extract));
  }

  getTemplate(id: string) {
    const endpoint = this.fileSetApiEndPoints['template'].replace('{id}', id);
    return this.http.get(endpoint)
      .pipe(map(extract));
  }

  newInstance(organizerId: string, instance)
  {
    const endpoint = this.fileSetApiEndPoints['newInstance'].replace('{organizerId}', organizerId);
    return this.http.post(endpoint, instance);
  }

  saveInstance(instanceId, state: Object) {
    const endpoint = this.fileSetApiEndPoints['saveInstance'].replace('{instanceId}', instanceId);
    return this.http.post(endpoint, {State: JSON.stringify(state)});
  }

  getInstance(id) {
    const endpoint = this.fileSetApiEndPoints['getInstance'].replace('{id}', id);
    return this.http.get(endpoint)
      .pipe(map(extract));
  }
}
